import { TELEGRAM } from "./config";

export async function sendTelegram(text) {
  const ids = TELEGRAM.chatIds || (TELEGRAM.chatId ? [TELEGRAM.chatId] : []);
  if (!TELEGRAM.botToken || ids.length === 0) return false;
  const url = `https://api.telegram.org/bot${TELEGRAM.botToken}/sendMessage`;

  const results = await Promise.all(
    ids.map(async (chatId) => {
      try {
        const res = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            chat_id: chatId,
            text,
            parse_mode: "HTML",
            disable_web_page_preview: true,
          }),
        });
        if (!res.ok) {
          const body = await res.text();
          return false;
        }
        return true;
      } catch (e) {
        return false;
      }
    })
  );
  return results.some(Boolean);
}

const esc = (s = "") =>
  String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

export function formatBooking(b) {
  return (
    "<b>🔔 Neue Anfrage — Hetlav Detailing</b>\n\n" +
    `<b>Name:</b> ${esc(b.name)}\n` +
    `<b>Telefon:</b> ${esc(b.phone)}\n` +
    `<b>E-Mail:</b> ${esc(b.email || "—")}\n` +
    `<b>Service:</b> ${esc(b.service)}\n` +
    `<b>Nachricht:</b> ${esc(b.message || "—")}\n\n` +
    `<i>${new Date().toLocaleString("de-AT")}</i>`
  );
}
